import React from 'react';
import PropTypes from 'prop-types';
import './SegmentsImageToggleButtonSelector.scss';

import ImageToggleButtonSelector from '../../../../common/ImageToggleButtonSelector/ImageToggleButtonSelector';

const getImageDimensionsByNumberOfSegments = (numSegments) => {
  if (numSegments <= 3) return { imageWidth: '274px', imageHeight: '170px' };
  if (numSegments === 4) return { imageWidth: '242px', imageHeight: '150px' };
  if (numSegments === 5) return { imageWidth: '192px', imageHeight: '119px' };
  if (numSegments === 6) return { imageWidth: '160px', imageHeight: '99px' };
  return { imageWidth: '140px', imageHeight: '85px' };
};

// The row is a space-between flex container. Up to six tiles share the fixed 1030px row; above
// that (ACR/Streaming with Purchase Affinities: 7-8 tiles) the tiles would be squeezed together,
// so the row grows to the tiles plus the same ~14px gap the six-tile layout has (PHOB-1889).
const TILE_GAP_PX = 14;
const getSelectorWidthByNumberOfSegments = (numSegments, imageWidth) => {
  if (numSegments <= 3) return '940px';
  if (numSegments <= 6) return '1030px';
  return `${numSegments * parseInt(imageWidth, 10) + (numSegments - 1) * TILE_GAP_PX}px`;
};

const SegmentsImageToggleButtonSelector = ({ segmentsData, selectedSegment, onToggle }) => {
  const { imageWidth, imageHeight } = getImageDimensionsByNumberOfSegments(segmentsData.length);
  const toggleButtonSelectorWidth = getSelectorWidthByNumberOfSegments(segmentsData.length, imageWidth);

  return (
    <div
      className="segments-image-toggle-button-selector-component"
      data-test-id="audience-builder-segment-type-picker"
      style={{ width: toggleButtonSelectorWidth }}
    >
      <ImageToggleButtonSelector
        togglesData={segmentsData}
        selectedToggle={selectedSegment}
        onToggle={onToggle}
        iconId="plus-in-a-box"
        imageWidth={imageWidth}
        imageHeight={imageHeight}
        isDownTriangleVisible={false}
      ></ImageToggleButtonSelector>
    </div>
  );
};

SegmentsImageToggleButtonSelector.propTypes = {
  segmentsData: PropTypes.array.isRequired,
  selectedSegment: PropTypes.string,
  onToggle: PropTypes.func.isRequired,
};

export default SegmentsImageToggleButtonSelector;
